import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export function usePreviousUrl() {
  const location = useLocation();
  const prevLocation = useRef<string | null>(null);

  useEffect(() => {
    prevLocation.current = location.pathname;
  }, [location]);

  return prevLocation.current;
}
